module.exports = __webpack_public_path__ + "02_short_black.f6ca76bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/02_short_black.png
// module id = l7TS
// module chunks = 0